import Vue from 'vue'
import CardsPanel from './cards/panel.vue'
import EventsPanel from './events/panel.vue';
import GalleryPanel from './gallery/panel.vue';
import KARPanel from './kar/panel.vue'
import ListPanel from './list/panel.vue'
import NewsPanel from './news/panel.vue'
import PeoplePanel from './people/panel.vue'
import SiteDirectory from './site-directory/panel.vue'
import SiteListing from './site-listing/panel.vue'

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

Vue.config.productionTip = false

var isCardsPanels = true;
var noCardsPanels = 0;
while (isCardsPanels) {
    if(document.getElementById("cards-output-" + noCardsPanels)){
        new Vue({
            el: '#cards-output-' + noCardsPanels,
            render(createElement) {
                var CardsArray = JSON.parse(localStorage.getItem('cardsArray-' + noCardsPanels));
                return createElement(CardsPanel, {
                    props: {
                        panel_number: noCardsPanels,
                        title: CardsArray.title,
                        description: CardsArray.description,
                        background: CardsArray.background,
                        card_labels: CardsArray.card_labels,
                        filters: CardsArray.filters,
                        labels: CardsArray.labels,
                        presets: CardsArray.presets,
                        panel_options: CardsArray.panel_options,
                        cards: CardsArray.cards
                    }
                });
            }
        })
        noCardsPanels++;
    } else {
        isCardsPanels = false;
    }
}

if(document.getElementById("events-output")){
    new Vue({
        el: '#events-output',
        render(createElement) {
            var eventsArray = JSON.parse(localStorage.getItem('eventsArray'));
            return createElement(EventsPanel, {
                props: {
                    background: eventsArray.background,
                    title: eventsArray.title,
                    display_date_header: eventsArray.display_date_header,
                    hide_filters: eventsArray.hide_filters,
                    use_external_url: eventsArray.use_external_url,
                    date_start: eventsArray.date_start,
                    date_end: eventsArray.date_end,
                    calendar: eventsArray.calendar,
                    item_count: eventsArray.item_count,
                    disable_show_more: eventsArray.disable_show_more,
                    button_label: eventsArray.button_label,
                    fallback_thumbnail: eventsArray.fallback_thumbnail,
                    locations: eventsArray.locations
                }
            });
        }
    })
}

if(document.getElementById("gallery-output")){
    new Vue({
        el: '#gallery-output',
        render(createElement) {
            var galleryArray = JSON.parse(localStorage.getItem('galleryArray'));
            return createElement(GalleryPanel, {
                props: {
                    images: galleryArray.images,
                    tags: galleryArray.tags,
                    flickr: galleryArray.flickr,
                    options: galleryArray.options
                }
            });
        }
    })
}

var isKARPanels = true;
var noKARPanels = 0
while (isKARPanels) {
    if (document.getElementById("kar-output-" + noKARPanels)) {
        new Vue({
            el: '#kar-output-' + noKARPanels,
            render(createElement) {
                var karArray = JSON.parse(localStorage.getItem('karArray-' + noKARPanels));
                return createElement(KARPanel, {
                    props: {
                        panel_number: noKARPanels,
                        division: karArray.division,
                        authors: karArray.authors,
                        signature_theme: karArray.signature_theme,
                        taxonomies: karArray.taxonomies,
                        publication_type: karArray.publication_type,
                        citation_style: karArray.citation_style,
                        limit: parseInt(karArray.limit),
                        sort: karArray.sort,
                        people_profile: karArray.people_profile
                    }
                });
            }
        });
        noKARPanels++;
    } else {
        isKARPanels = false;
    }
}

var isListPanels = true;
var noListPanels = 0;
while (isListPanels) {
    if(document.getElementById("list-output-" + noListPanels)){
        new Vue({
            el: '#list-output-' + noListPanels,
            render(createElement) {
                var listArray = JSON.parse(localStorage.getItem('listArray-' + noListPanels));
                return createElement(ListPanel, {
                    props: {
                        panel_number: noListPanels,
                        title: listArray.title,
                        search_filter: listArray.search,
                        tags_filter: listArray.tags,
                        links: listArray.links
                    }
                });
            }
        })
        noListPanels++;
    } else {
        isListPanels = false;
    }
}

var isNewsPanels = true;
var noNewsPanels = 0;
while (isNewsPanels) {
    if(document.getElementById("news-output-" + noNewsPanels)){
        new Vue({
            el: '#news-output-' + noNewsPanels,
            render(createElement) {
                var newsArray = JSON.parse(localStorage.getItem('newsArray-' + noNewsPanels));
                return createElement(NewsPanel, {
                    props: {
                        panel_number: noNewsPanels,
                        type: newsArray.type,
                        article_id: newsArray.article_id,
                        background: newsArray.background,
                        title: newsArray.title,
                        posts: newsArray.posts,
                        item_count: newsArray.item_count,
                        disable_show_more: newsArray.disable_show_more,
                        button_label: newsArray.button_label,
                        news_dropdown: newsArray.news_dropdown,
                        category_preset: newsArray.category_preset,
                        fallback_thumbnail: newsArray.fallback_thumbnail,
                        hide_date: newsArray.hide_date,
                        social_share_links: newsArray.social_share_links
                    }
                });
            }
        });
        noNewsPanels++;
    } else {
        isNewsPanels = false;
    }
}

if(document.getElementById("people-output")){
    new Vue({
        el: '#people-output',
        render(createElement) {
            var peopleArray = JSON.parse(localStorage.getItem('peopleArray'));
            return createElement(PeoplePanel, {
                props: {
                    people: peopleArray.people,
                    groups: peopleArray.groups,
                    group_labels: peopleArray.group_labels,
                    filters: peopleArray.filters,
                    orderby: peopleArray.orderby,
                    order: peopleArray.order
                }
            });
        }
    })
}

if(document.getElementById("site-directory")){
    new Vue({
        el: '#site-directory',
        render(createElement) {
            var sitesArray = JSON.parse(localStorage.getItem('site-directory-array'));
            return createElement(SiteDirectory, {
                props: {
                    site_parent_domain: sitesArray.site_parent_domain,
                    sites_array: sitesArray.sites_array,
                    divisions_array: sitesArray.divisions_array,
                    site_types_array: sitesArray.site_types_array,
                    research_strengths_array: sitesArray.research_strengths_array,
                    srt_array: sitesArray.srt_array
                }
            });
        }
    })
}

if(document.getElementById("site-listing")){
    new Vue({
        el: '#site-listing',
        render(createElement) {
            var sitesArray = JSON.parse(localStorage.getItem('sitesArray'));
            return createElement(SiteListing, {
                props: {
                    sites_array: sitesArray.sites_array,
                    categories_array: sitesArray.categories_array,
                    prefilters: sitesArray.prefilters,
                    panel_options: sitesArray.panel_options
                }
            });
        }
    })
}